export const MemberTypeConstants = {
    REGULAR_MEMBER: 'b4e83774-16a2-4c17-8e2b-1bbb030eea6e',
    NON_MEMBER: '15a56ab9-0b46-4646-8971-222eaa901779',
    DISCONTINUE: '4d887c4c-34ab-4837-8187-2f05ffeee9dd',
    DEDICATED_JUNIOR_MEMBER: '9881b4dd-c9fd-4e53-b711-30cc7ef549cc',
    DEDICATED_REGULAR_MEMBER: '80e25033-1086-4da4-95a0-55bea668da1c',
    DEDICATED_LIFE_MEMBER: '1f82af54-3703-47d9-85a3-5877c92b887e',
    DEDICATED_SENIOR_MEMBER: 'db9cdd7a-3020-48b0-ab1c-a99cbaeea9c0',
    SENIOR_MEMBER: '0b680d9c-76ad-44ea-adc4-ae7cb26b3e1e',
    DECEASED: 'b75f3514-43b7-4b39-ae7a-d0cfa9e94a15',
    LIFE_MEMBER: 'c14a6885-723f-48b9-9fd9-fb957601b282',
    JUNIOR_MEMBER: '8867b371-9feb-48da-9d15-fc9edbeb811b',
    LAPSED: 'ee80a54f-1799-44b0-b73b-fe6fdbeb85ea'
}